import React from 'react';
import { FaUser, FaChild, FaBaby } from 'react-icons/fa'; // ikony
import Tooltip from '../tooltip/Tooltip'; // Twój komponent tooltipa

const GuestsSummary = ({ guests }) => {
  if (!guests) return null;

  return (
    <div className="d-flex align-items-center gap-3">
      {/* Dorośli */}
      <div className="d-flex align-items-center gap-1">
        <Tooltip tooltip="Dorośli 13+">
          <FaUser size={18} />
        </Tooltip>
        <span>{guests.adults ?? 0}</span>
      </div>

      {/* Dzieci */}
      <div className="d-flex align-items-center gap-1">
        <Tooltip tooltip="Dzieci 7-12">
          <FaChild size={18} />
        </Tooltip>
        <span>{guests.children ?? 0}</span>
      </div>

      {/* Niemowlęta */}
      <div className="d-flex align-items-center gap-1">
        <Tooltip tooltip="Małe dzieci 0-6">
          <FaBaby size={18} />
        </Tooltip>
        <span>{guests.infants ?? 0}</span>
      </div>
    </div>
  );
};

export default GuestsSummary;
